import type { AxiosInstance } from 'axios'

export const installRequestInterceptor = ({
  apiClient,
  sessionToken,
}: {
  apiClient: AxiosInstance
  sessionToken: string | null
}) => {
  apiClient.interceptors.request.clear()
  apiClient.interceptors.request.use(
    config => {
      if (sessionToken) {
        config.headers!.Authorization = `Bearer ${sessionToken}`
      } else {
        delete config.headers!.Authorization
      }
      return config
    },
    error => {
      Promise.reject(error)
    }
  )
}
